export const MODULE_ID = 'mobile';
export const DIABETES_TYPES = [
    'NoResponse',
    'Type1',
    'Type2',
    'GDM',
    'PreDiabetes',
    'NotSure'
];
export const TREATMENT_TYPES = [
    'NoResponse',
    'Insulin',
    'Oral',
    'Combination',
    'Lifestyle'
];
export const DIABETES_DETAILS_FORM = `${MODULE_ID}.diabetesDetailsForm`;
export const CONFIRM_SIGN_OUT_MODAL = `${MODULE_ID}/confirmSignOutModal`;
export const CONSENT_MODAL = `${MODULE_ID}/consentModal`;
